export default {
  home_title: '01Web - Smart Portal homepage',
  home_change_mune: '0108Web-Switch menu',
  home_more_learn_footprint: 'View more',
  home_more: '0112Web-Homepage-View more',
  home_see_learn_tasks: '0109Web-View learning task entries',
  home_click_banner: '0110Web - Click Banner',
  home_Team_management: 'Team Learning Management',
  home_click_content: '0111Web-Homepage-Click content'
}
